// interface player {
// 	audio: HTMLAudioElement;
// 	product?: HTMLElement;
// 	play?: (productId: number, fileId: number, filePath?: string) => void;
// 	progressbar?: HTMLElement;
// 	pause: () => void;
// 	onChange: () => void;
// 	toggleVolume: () => void;
// 	next: () => void;
// 	prev: () => void;
// 	productId: number;
// 	fileId: number;
// 	isPlaying: boolean;
// 	isLoading: boolean;
// }
// console.log("click16");
// // fix iphone
// if (window.innerWidth < 600) {
// 	const volume = player.audio.volume;
// 	player.audio.volume = 0;
// 	player.audio.src = `https://yesbeat.ru/files/mp3/5035/2019%20Hits%20Volume%202%20EN%20(130%20BPM,%2059%20min,%20January%202020)-social.mp3`;
// 	player.audio.play();
// 	player.audio.volume = volume;
// 	player.audio.pause();
// 	console.log("click6");
// }
// // END  fix iphone

const jsVolume = document.querySelectorAll<HTMLElement>(`.jsVolume`);
jsVolume.forEach((item) => {
	item.onclick = () => {
		player.toggleVolume();
	};
});
interface Props {
	productId: number;
	onChange: () => void;
	onCanplay: () => void;
	onPlay: () => void;
	onPause: () => void;
	onEnded: () => void;
	onWaiting: () => void;
	next: () => void;
}

const getProgressBarClickInfo = (progress_bar: HTMLElement, e: any) => {
	const x = e.pageX - progress_bar.offsetLeft;
	const y = e.pageY - progress_bar.offsetTop;
	const max = parseInt(progress_bar.dataset.max || "");
	const value = (x * max) / progress_bar.offsetWidth;
	return {
		x: x,
		y: y,
		max: max,
		value: value,
	};
};
type Dom = {
	audio: HTMLAudioElement;
	progressbar: HTMLElement | null;
	list: null;
};
class Player {
	dom: Dom;
	props: Props;
	state: any;
	constructor() {
		this.dom = {
			audio: <HTMLAudioElement>document.createElement("AUDIO"),
			progressbar: <HTMLElement | null>null,
			list: null,
		};
		this.props = {
			productId: 0,
			onChange: () => {},
			onCanplay: () => {},
			onPlay: () => {},
			onPause: () => {},
			onEnded: () => {},
			onWaiting: () => {},
			next: () => {},
		};
		this.state = {};
	}
	setControlsNodes(progressbar: HTMLElement) {
		this.dom.progressbar = progressbar;
		this.dom.audio.addEventListener(
			"timeupdate",
			() => {
				if (this.dom.progressbar) {
					const line =
						this.dom.progressbar.querySelector<HTMLElement>(
							".line"
						);
					if (line) {
						line.style.width = `${(
							(this.dom.audio.currentTime * 100) /
							this.dom.audio.duration
						).toFixed()}%`;
					}
				}
			},
			false
		);
		progressbar.onclick = (event: any) => {
			const info = getProgressBarClickInfo(progressbar, event);
			const value = (this.dom.audio.duration / info.max) * info.value;
			this.dom.audio.currentTime = parseFloat(value + "");
		};
	}
	init() {
		this.destroy();
		// this.props = props;
		// player.dom.audio.src = ``;
		this.dom.audio.volume = 0.5;

		this.dom.audio.addEventListener("canplay", () => {
			// console.log("canplay");
			this.props.onCanplay();
			this.dom.audio.play();
		});
		this.dom.audio.addEventListener("play", () => {
			// console.log("play");
			this.props.onPlay();
		});
		this.dom.audio.addEventListener("pause", () => {
			// console.log("pause");
			this.props.onPause();
		});

		this.dom.audio.addEventListener("waiting", () => {
			this.props.onWaiting();
		});
		this.dom.audio.onended = () => {
			this.props.onEnded();
		};
		this.dom.audio.addEventListener("error", () => {
			if (this.dom.audio.error?.code === 4) {
				console.log("error");
				this.props.next();
			}
		});
	}
	setProps(props: Props) {
		this.props = props;
	}
	destroy() {
		// this.dom.audio.removeEventListener('canplay')
	}
	toggleVolume() {
		// alert("jsVolume toggleVolume")

		if (this.dom.audio.volume > 0) {
			this.dom.audio.volume = 0;
			jsVolume.forEach((item) => item.classList.add("off"));
		} else {
			this.dom.audio.volume = 0.5;
			jsVolume.forEach((item) => item.classList.remove("off"));
		}
	}
	play(filePath: string) {
		// console.log("Player play filePath", filePath);
		if (filePath) {
			const src = "https://yesbeat.ru/" + filePath;
			if (src !== decodeURI(this.dom.audio.src)) {
				this.dom.audio.src = src;
			}
			this.dom.audio.play();
		} else {
			this.props.next();
		}
		this.onChange();
	}
	pause() {
		this.dom.audio.pause();
	}
	onChange() {
		this?.props?.onChange();
	}
}

//  END player;

const player = new Player();
player.init();
(<any>window).player = player;
export default player;
